/**
 * TODO
 * WIP
 */
import React from 'react';

import { css, cx } from '@emotion/css';
import { Theme } from '@mui/material';

import { useStyles } from '@/hooks/useStyles';
import { AtomProps, StyleClasses } from '@/uiKit/atoms/utils/AtomTypes.ts';

export type BaseSeparatorProps = {
  text?: string;
  className?: string;
};

export type SeparatorProps = AtomProps<
  BaseSeparatorProps,
  StyleClasses<'root' | 'separator' | 'content' | 'text'>
>;

export const Separator: React.FC<SeparatorProps> = ({
  className,
  text,
  classes,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <div className={cx(styles.container, className, classes?.root)} {...props}>
      <div className={cx(styles.separator, classes?.separator)}></div>
      {text && (
        <span className={cx(styles.content, classes?.content)}>
          <span className={cx(styles.text, classes?.text)}>{text}</span>
        </span>
      )}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    width: 100%;
    height: ${theme.spacing(8)};
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    position: relative;
  `,
  separator: css`
    width: 100%;
    height: 1px;
    flex-shrink: 0;
    position: absolute;
  `,
  content: css`
    display: inline-flex;
    height: ${theme.spacing(8)};
    padding: ${theme.spacing(0, 8)};
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing(4)};
    flex-shrink: 0;
    background: ${theme.palette.common.white};
    position: absolute;
    z-index: 2;
  `,
  text: css`
    text-transform: capitalize;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.2px;
  `,
});
